/** @format */

import { HmfButtonComponent, HmfModalComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCancel
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewModalComponent } from './review-modal.component';
import { ReviewSectionModule } from '../review-section/review-section.module';
import { TrapFocusModule } from '../directive/trap-focus/trap-focus.module';

@NgModule({
	imports: [
		CommonModule,
		HmfButtonComponent,
		HmfModalComponent,
		HomefieldIconLibraryModule,
		ReviewSectionModule,
		TrapFocusModule
	],
	declarations: [ReviewModalComponent],
	exports: [ReviewModalComponent]
})
export class ReviewModalComponentModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
	}
}
